export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Grupo',
    route: 'grupo',
    icon: 'UsersIcon',
  },
  {
    title: 'Usina',
    route: 'usina',
    icon: 'UnderlineIcon',
  },
  {
    title: 'Upload',
    route: 'upload',
    icon: 'ArrowUpIcon',
  },
]
